import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { OrderSummary } from '../../models/cart-item';
import { OrdersService } from '../../service/orders.service';
import { ProgressLoaderService } from '../../service/progress-loader.service';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { showErrorToast, showSuccessToast } from '../../utilities/toast-utils';
import { LanguageService } from '../../service/language.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import { ScreenSizeService } from '../../service/screen-size.service';
import { OrderListCardComponent } from '../common/order-list-card/order-list-card.component';
import { CustomToastrService } from '../../service/custom-toastr.service';

@Component({
    selector: 'app-list-orders',
    standalone: true,
    imports: [
        CommonModule,
        TableModule,
        ButtonModule,
        TooltipModule,
        TranslateModule,
        OrderListCardComponent,
    ],
    templateUrl: './list-orders.component.html',
    styleUrl: './list-orders.component.scss',
})
export class ListOrdersComponent {
    loading: boolean = false;
    orders: OrderSummary[] = [];
    selectedLanguage: any = null;
    openOrdersCount: number = 0;

    constructor(
        private ordersService: OrdersService,
        private progressLoader: ProgressLoaderService,
        private messageService: MessageService,
        private router: Router,
        private wiseToastr: CustomToastrService,
        private languageService: LanguageService,
        private translate: TranslateService,
        private screenSizeService: ScreenSizeService
    ) {}

    ngOnInit(): void {
        this.getCustomerOrders();
    }

    viewOrderDetails(driver: any) {
        this.router.navigate(['/home/orders/'.concat(driver.id)]);
    }

    initializeLocale() {
        this.languageService.currentLanguage$.subscribe((language) => {
            this.selectedLanguage = language;
            this.setLanguage(this.selectedLanguage);
        });
    }

    getDeviceType(): string {
        return this.screenSizeService.getDeviceType();
    }

    setLanguage(language: string) {
        this.translate.use(language);
        this.languageService.setLanguage(language);
    }

    rowClass(rowData: OrderSummary): string {
        return rowData.status === 'OPEN' ? 'call-to-action' : '';
    }

    getOpenOrdersCount(orders: OrderSummary[]): number {
        return orders.filter((order) => {
            return order.status === 'OPEN';
        }).length;
    }

    getCustomerOrders() {
        this.progressLoader.show('Fetching customers orders');
        this.ordersService.listOrders().subscribe({
            next: (result) => {
                this.orders = result;
                this.openOrdersCount = this.getOpenOrdersCount(this.orders);
                
                this.progressLoader.hide();
            },
            error: (err) => {
                this.showError(this.translate.instant(err.error.messageKey))
                this.progressLoader.hide();
            },
        });
    }

    showSuccess(message: string) {
        this.wiseToastr.showSuccess(message);
    }

    showError(message: string) {
        this.wiseToastr.showError(message);
    }

    delete(orderId: string) {
        this.loading = true;
        this.ordersService.deleteOrder(orderId).subscribe({
          next: (value: any) => {
            this.loading = false;
            this.showSuccessToastr("Vehicle deleted successfully");
            this.getCustomerOrders();
          },
          error: (err: any) => {
            this.showError(this.translate.instant(err.error.messageKey))
            this.loading = false;
          }
        })
      }
      showSuccessToastr(message: string){
        this.wiseToastr.showSuccess(message);
      }

      showErrorToastr(message: string){
        this.wiseToastr.showError(message);
      }
}
